module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp1_2.9a9d8db0.png";